<template>
    <b-card class="standardpage reports invoices border-none" :class="headerShow ? 'px-3' : null">
        <b-card-header class="px-3 m-0" v-if="headerShow">
            <b-row align-h="between">
                <b-col cols="auto" class="text-sm-left pt-1">
                    <i :class="header.icon" class="mr-1"></i>
                    {{ header.title }}
                </b-col>

                <b-col class="text-right">
                    <b-button squared size="sm" variant="outline-primary" @click="back()">
                        <i class="fa fa-chevron-left pr-1"></i>Back
                    </b-button>
                </b-col>
            </b-row>

        </b-card-header>
        <!-- {{ item }} -->
        <div class="availtable datatable text-left" :class="headerShow ? 'px-3' : null">
            <b-row class="mt-3 mb-3">
                <b-col cols="" class="text-left">
                    <b-row no-gutters>
                        
                        <b-col align-self="center" cols="auto"> <img class="logo w-60px inline mr-2"
                                :src="account.banklogo" :alt="account.bankname" :title="account.bankname" /></b-col>
                        <b-col>
                            <div class="strong text-3x">{{ account.accountname }}</div>
                            <div><span class="h6">{{ bankno }} </span></div>
                        </b-col>
                    </b-row>
                </b-col>
                <!-- <b-col class="text-right">
                    <b-row align-h="end mr-2">
                        <b-col cols="auto">
                            <div class="strong text-3x text-right">{{ account.statement_balance | currency("") }}</div>
                            <div><span class="h6">Statement Balance ( {{ $moment.unix(account.statement_at *
        .001).format("DD MMM YY") }} )</span></div>
                        </b-col>
                        <b-col v-if="unreconciled > 0" cols="auto">
                            <div class="strong text-3x">(unknown)</div>
                            <div><span class="h6">Balance in BOP</span></div>
                        </b-col>
                        <b-col v-if="unreconciled == 0" cols="auto">
                            <div class="text-primary text-3x strong"><i class="fa fa-check-circle pr-2"></i>Reconciled
                            </div>
                        </b-col>
                    </b-row>
                </b-col> -->
            </b-row>
            <b-card-body class="pb-0 pt-3 px-0">
                <b-tabs class="gridtabs" v-model="action_tab">
                    <b-tab :active="true"> <template #title>
                            <i class="fa fa-file-text-o text-primary mr-1"></i> Spend rule
                        </template>

                        <b-row no-gutters>
                            <b-col class="strong text-2x pt-2">1. Apply a rule</b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <b-form-group label="Conditions match" label-for="matchconditions" label-cols="12">
                                    <b-form-radio-group id="matchconditions" v-model="conditions.matchconditions"
                                        :options="[
        { text: 'Any', value: 'Any' },
        { text: 'All', value: 'All' },
    ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"></b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>Add conditions</b-col>
                        </b-row>
                        <!-- <b-row class="mt-3"><b-col>{{ id }}</b-col></b-row> -->

                        <!-- <b-row class="mt-3">
                            <b-col> Reference</b-col>
                            <b-col> Equals</b-col>
                            <b-col> {{ item.reference }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col> Description</b-col>
                            <b-col> Equals</b-col>
                            <b-col> {{ item.descritpion }}</b-col>
                        </b-row> -->

                        <e-table :refid="conditions.refid" :busy="conditions.busy" :icon="conditions.icon"
                            :tools="conditions.tools" :fields="conditions.fields" :items="conditions.items"
                            :showpages="false" :showfab="false" />

                        <!-- @click="table_e_click"
                        @select="table_e_select"
                        @change="updateit" -->

                        <b-row class="my-2" no-gutters>
                            <b-col class="strong text-2x pt-2">2. Set the contact</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="To an existing or new contact" label-for="contact_type"
                                    label-cols="12">
                                    <treeselect instanceId="contact_type" type="number"
                                        v-model="conditions.contact_type" :clearable="true"
                                        :options="contacttype_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Contact" label-for="contact" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="conditions.contact"
                                            placeholder="Enter contact" size="sm"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                @click="conditions.contact = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="my-2" no-gutters>
                            <b-col class="strong text-2x pt-2">3. Allocate line items</b-col>
                        </b-row>
                        <b-row>
                            <b-col>Automatically allocate fixed value line items</b-col>
                        </b-row>

                        <e-table :refid="lineitems.refid" :busy="lineitems.busy" :icon="lineitems.icon"
                            :tools="lineitems.tools" :fields="lineitems.fields" :items="lineitems.items"
                            :showpages="false" :showfab="false" />

                        <b-row class="mt-4">
                            <b-col>With any remainder allocate ratios using percent line items</b-col>
                        </b-row>

                        <e-table :refid="lineitemsratios.refid" :busy="lineitemsratios.busy"
                            :icon="lineitemsratios.icon" :tools="lineitemsratios.tools" :fields="lineitemsratios.fields"
                            :items="lineitemsratios.items" :showpages="false" :showfab="false" />

                        <b-row class="my-2" no-gutters>
                            <b-col class="strong text-2x pt-2">4. Set the reference</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Set the reference" label-for="reference" label-cols="12">
                                    <treeselect instanceId="reference" type="number" v-model="conditions.reference"
                                        :clearable="true" :options="reference_options"></treeselect>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="my-2" no-gutters>
                            <b-col class="strong text-2x pt-2">5. Add rule details</b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Run this rule on" label-for="ruledetails" label-cols="12">
                                    <treeselect instanceId="ruledetails" type="number" v-model="conditions.ruledetails"
                                        :clearable="true" :options="rule_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Name the rule" label-for="rulename" label-cols="12">
                                    <b-input-group>
                                        <b-form-input type="text" v-model="conditions.rulename"
                                            placeholder="Enter rule name" size="sm"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                @click="conditions.rulename = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>


                    </b-tab>
                    <b-tab> <template #title>
                            <i class="fa fa-file-text-o text-primary mr-1"></i> Receive rule
                        </template>
                        <b-row>
                            <b-col>Receive rule content</b-col>
                        </b-row>

                    </b-tab>
                    <b-tab> <template #title>
                            <i class="fa fa-file-text-o text-primary mr-1"></i> Transfer rule
                        </template>
                        <b-row>
                            <b-col>Transfer rule content</b-col>
                        </b-row>

                    </b-tab>
                </b-tabs>

            </b-card-body>

            <b-card-footer class="mx-0 nopadding mt-2">
                <b-row no-gutters>

                    <b-col class="text-right" cols="12">
                        <b-button squared size="sm" variant="secondary" @click="back()">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>

        </div>
    </b-card>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BankingRules",
    props: {
        parent_id: { type: String, default: "" },
        showback: { type: Boolean, default: false },
    },

    data() {
        return {
            header: {
                title: "Banking",
                icon: "fa fa-university text-primary",
                debounce: 500,
            },
            headerShow: true,
            showback: true,
            busy: false,
            action_tab: 0,
            id: null,
            item: {
                id: null,
                type: "debit",
            },
            lineitem : {
                id: null
            },
            type_options: [
                { id: "credit", label: "Credit" },
                { id: "debit", label: "Debit" },
            ],
            contacttype_options: [{ id: "existing", label: "Existing" }, { id: "new", label: "New" }],
            reference_options: [{ id: "xxx", label: "XXX" }],
            rule_options: [{ id: "businesscredit", label: "Business Credit" }],
           
            conditions: {
                refid: "conditions",
                busy: false,
                icon: "fa fa-bolt text-primary",
                matchconditions: 'Any',

                tools: "go,export,add,deleteconfirm",
                fields: [
                    {
                        key: "field",
                        label: "Field",
                        type: "text",
                        placeholder: "Field",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "condition",
                        label: "Condition",
                        type: "text",
                        placeholder: "Condition",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "value",
                        label: "Value",
                        type: "text",
                        placeholder: "",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                ],
                // fields: [
                //   {
                //     key: "slac",
                //     label: "SL A/C",
                //     type: "treeselect",
                //     class: "text-center w-20pct",
                //     clearable: "true",
                //   },
                //   {
                //     key: "routing",
                //     label: "Routing",
                //     type: "text",
                //     class: "text-right w-30pct",
                //     multiple: "true",
                //     clearable: "true",
                //     datalist: ["ABC/DEF", "GHI/JKL"],
                //   },
                //   {
                //     key: "datetravel",
                //     label: "Date Travel",
                //     type: "daterangepicker",
                //     class: "text-right w-30pct",
                //     singleDatePicker: "range",
                //     opens: "left",
                //     clearable: "true",
                //   },
                //   {
                //     key: "value",
                //     label: "Value",
                //     type: "text",
                //     class: "text-right w-20pct",
                //     disabled: "true",
                //   },
                // ],
                items: [
                    {
                        field: "Reference",
                        condition: "equals",
                        value: "",
                    },
                    {
                        field: "Description",
                        condition: "equals",
                        value: "",
                    },
                ],
                selected: [],
            },

            lineitems: {
                refid: "lineitems",
                busy: false,
                icon: "fa fa-list text-primary",

                tools: "go,export,add,deleteconfirm",
                fields: [
                    {
                        key: "description",
                        label: "Description",
                        type: "text",
                        placeholder: "Description",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "account",
                        label: "Account",
                        type: "text",
                        placeholder: "Account",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "taxrate",
                        label: "Tax Rate",
                        type: "text",
                        placeholder: "",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        type: "text",
                        placeholder: "",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                ],
                items: [],
                selected: [],
            },

            lineitemsratios: {
                refid: "lineitemsratios",
                busy: false,
                icon: "fa fa-list text-primary",

                tools: "go,export,add,deleteconfirm",
                fields: [
                    {
                        key: "description",
                        label: "Description",
                        type: "text",
                        placeholder: "Description",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "account",
                        label: "Account",
                        type: "text",
                        placeholder: "Account",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "taxrate",
                        label: "Tax Rate",
                        type: "text",
                        placeholder: "",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                    {
                        key: "percent",
                        label: "Percent",
                        type: "text",
                        placeholder: "",
                        class: "text-right w-100px",
                        clearable: "true",
                    },
                ],
                items: [],
                selected: [],
            },
        };
    },
    watch: {
        // async matchconditions() {
        //     await this.bankingrules_load(0);
        // },
        parent_id: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.account_id = newVal
                    this.headerShow = false
                }
            }
        },
        "$route.query": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('changed $route.query', newVal)
                if (newVal.id) {
                    this.id = newVal.id
                    this.action_tab = 0
                    this.headerShow = true
                }
            }
        },
        account_id: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log('loading new id', newVal)
                    await this.bankings_load(newVal)
                    this.action_tab = 0
                }
            }
        },
        id: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log('loading new id', newVal)
                    await this.bankingslines_load(newVal)
                    this.action_tab = 0
                }
            }
        },

    },
    computed: {
        readonly() {
            return true;
        },
        account() {
            return this.item;
        },

        router_loaded() {
            if (this.$route.query.id) {
                return true
            } else {
                return false
            }
        },
        postit_visible() {
            if (this.user.permissions.includes('bankings.save') && this.action_tab != 0) {
                return true
            } else {
                return false
            }
        },
        postit_enabled() {
            if (this.user.permissions.includes('bankings.save')) {
                return true
            } else {
                return false
            }
        },
        bankno() {
            return this.account.sortno + '-' + this.account.accountno
        }

    },
    methods: {
        async back() {
            if (!this.router_loaded) {
                this.$emit('discard')
            } else {
                this.$router.back(-1)
            }
            this.parent_id = ""
            this.account_id = ""
        },
        async bankings_load(id) {
            let variables = {
                id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankings(
                            $id: String  
                        ) {
                            bankings(
                            id: $id            
                        ) {
                            id
                            accountname                    
                            bankname
                            banklogo  
                            sortno
                            accountno
                         }
                        }
                    `,
                    variables,
                });

                if (response.data.bankings.length > 0) {
                    this.item = response.data.bankings[0];

                    if (this.item.open_at) {
                        let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                        if (this.item.open_at != 'NaN') {
                            v = this.$moment.unix(this.item.open_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                        }
                        this.dateopen = { startDate: v, endDate: v }
                    }
                }
            } catch (error) {
                console.log(error);
            }

            await this.reconcile_load(0)

        },
        async bankingslines_load(id) {

            let variables = {
                id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines (
                            $id: String
                        ) {
                            bankingslines (
                            id: $id                              
                        ) {
                            id
                            type
                            date_at
                            description
                            payee
                            reference
                            amount
                            spent
                            received
                            balance
                            source
                            status
                            data
                            analysis
                            account_id
                            created_at
                            created_by
                            updated_by
                            updated_at
                            rows
                        }
                        }
                        `,
                    variables,
                });

                if (response.data.bankingslines.length > 0) {
                    this.lineitem = response.data.bankingslines[0];
                    this.conditions.items[0].value = this.lineitem.reference
                    this.conditions.items[1].value = this.lineitem.description

                    await this.bankings_load(this.lineitem.account_id)
                }

            } catch (error) {
                console.log(error);
            }


        },

        async bankingrules_load(offset, limit, page) {

            let state = this.bankingrules;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                id: this.id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query bankingslines (
                   $id: String
            ) {
                bankingslines (
                id: $id                              
            ) {
                id
                type
                date_at
                description
                payee
                reference
                amount
                spent
                received
                balance
                source
                status
                data
                analysis
                account_id
                created_at
                created_by
                updated_by
                updated_at
                rows
            }
            }
        `,
                    variables,
                });

                if (limit == 0) {
                    state.selected = response.data.bankingslines
                } else {
                    state.items = []
                    state.items = response.data.bankingslines;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async bankingrules_click(a, ss) {
            console.log('bankingrules_click', a)

            let state = this.bankingrules;

            switch (a) {
                case "selectall":
                    break;
                case "filter":
                    state.filter = !state.filter;
                    break;
                case "discard":
                    this.component = null
                    await this.bankingrules_load(0)
                    break;
                case "go":
                    await this.bankingrules_load(0)
                    break;
                case "add":
                case "edit":
                    state.edit = !state.edit
                    break;
                case "delete":
                    await this.bankingrules_delete(ss)
                    break;
                case "back":
                    this.$router.go(-1)
                    break;

            }
        },
        async bankingrules_select(ss, tools) {

            let state = this.bankingrules;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "export", "add"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                if (state.selected.length > 0) {
                    state.item = state.selected[0]  // WHAT YOU SELECTED

                    let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.date_at != 'NaN') {
                        v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    this.bankingrules.editdatestatement = { startDate: v, endDate: v }
                } else {
                    state.item = {}
                }
            }
        },
        async bankingrules_save(ss) {

            let variables = {
                rows: this.cleanit(ss),
            };
            console.log(variables)
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
        mutation bankingslines_save(
            $rows: [BankingLine_input]               
        ) {
            bankingslines_save(rows: $rows) {
            id
            }
        }
        `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

        },
        async bankingrules_delete(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
mutation bankingslines_delete($rows: [BankingLine_input]) {
    bankingslines_delete(rows: $rows) {
    id
    }
}
`,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.bankingrules_load(0);
        },


    },
};
</script>

<style></style>